module.exports = __webpack_public_path__ + "static/img/wealth_level_73.084205b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_73.png
// module id = ADO5
// module chunks = 0